// Initialize AWIN object
var AWIN = AWIN || {};
AWIN.Tracking = AWIN.Tracking || {};

document.addEventListener('DOMContentLoaded', function() {
    // Check if in Shopify preview/editor mode
    const isShopifyPreview = window.Shopify && window.Shopify.designMode;

    if (isShopifyPreview) {
        // Hide the cookie banner in preview mode
        const cookieBanner = document.querySelector('.isense-cookieconsent-wrapper');
        if (cookieBanner) {
            cookieBanner.style.display = 'none';
        }
        // Skip any further cookie consent handling
        return;
    }

    // Rest of your code for non-preview mode
    // Check if consent was previously given
    const hasConsent = document.cookie.includes('isense-cookieconsent=accept');
    if (hasConsent) {
        AWIN.Tracking.AdvertiserConsent = true;
        if (AWIN.Tracking.Consent && typeof AWIN.Tracking.Consent.setAdvertiserConsentStatus === 'function') {
            AWIN.Tracking.Consent.setAdvertiserConsentStatus(true);
        }
    } else {
        AWIN.Tracking.AdvertiserConsent = false;
    }

    const checkForConsent = setInterval(function() {
        const cookieBanner = document.querySelector('.isense-cookieconsent-wrapper');
        if (cookieBanner) {
            // Cookie banner exists, set consent to true if cookie exists
            if (hasConsent) {
                AWIN.Tracking.AdvertiserConsent = true;
                if (AWIN.Tracking.Consent && typeof AWIN.Tracking.Consent.setAdvertiserConsentStatus === 'function') {
                    AWIN.Tracking.Consent.setAdvertiserConsentStatus(true);
                }
                // Clear the interval once consent is confirmed
                clearInterval(checkForConsent);
            }
        }
    }, 500);

    // Also handle the consent button click
    const checkForButton = setInterval(function() {
        const consentButton = document.querySelector('.isense-cc-submit-consent');
        if (consentButton) {
            clearInterval(checkForButton);
            
            consentButton.addEventListener('click', function() {
                try {
                    // Set a cookie to persist consent across page reloads
                    document.cookie = "isense-cookieconsent=accept; path=/; max-age=31536000"; // 1 year expiry
                    
                    AWIN.Tracking.AdvertiserConsent = true;
                    if (AWIN.Tracking.Consent && typeof AWIN.Tracking.Consent.setAdvertiserConsentStatus === 'function') {
                        AWIN.Tracking.Consent.setAdvertiserConsentStatus(true);
                    }
                    
                    // Clear both intervals to ensure they stop running
                    clearInterval(checkForConsent);
                    clearInterval(checkForButton);
                } catch (error) {
                    console.error('Error setting AWIN consent:', error);
                }
            });
        }
    }, 500);
});